import { FiLayers } from "react-icons/fi";
import { HiOutlinePencil } from "react-icons/hi";
import {
  FaCarSide,
  FaMoneyBillWave,
  FaTruck,
  FaTruckLoading,
  FaCogs,
  FaLink,
  FaRegCalendarAlt,
  FaRocket,
} from "react-icons/fa";

export const paths = {
  home: "/",
  login: "/login",
  placeOrder: "/place-order",
  testOrder: "/test-order",
  cars: "/cars",
  samePartOrders: "/same-part-orders",
  engine3D: "/engine",
  metrics: "/metrics/:orderHandlerId",
  customers: "/unique-customers",
  r2dOrders: "/r2d-orders",
  shipmentsDashboard: "/shipments-dashboard",
  partAvailability: "/part-availability",
  unpaidOrders: "/unpaid-orders",
  addCatalogPart: "/add-catalog-part/:orderNo/:partId",
  cboOrders: "/cbo-orders",
  missionControl: "/mission-control",
};

export const pageTitles = {
  placeEnquiry: "Place Enquiry",
  testOrder: "Test Order",
  orders: "Orders",
  cars: "Cars",
  samePartOrders: "Same Part Orders",
  r2dOrders: "R2D Orders",
  shipmentsDashboard: "Shipments",
  partAvailability: "Part Availability",
  unpaidOrders: "Outstanding",
  partMaster: "Part Master",
  PaymentLinks: "Payment Links",
  CBOOrders: "CBO Orders",
  MISSION_CONTROL: "MC",
};

export const NavNames = {
  placeEnquiry: "Place Enquiry",
  testOrder: "T.O.",
  orders: "Orders",
  cars: "Cars",
  samePartOrders: "Same Part Orders",
  r2dOrders: "R2D Orders",
  shipmentsDashboard: "Shipments",
  partAvailability: "Part Availability",
  unpaidOrders: "Outstanding",
  partMaster: "Part Master",
  PaymentLinks: "Payment Links",
  CBOOrders: "CBO Orders",
  MISSION_CONTROL: "MC",
};

export const pathObject = [
  {
    main: { name: pageTitles.orders },
    sub: [
      {
        name: NavNames.orders,
        path: paths.home,
        icon: FiLayers,
      },
    ],
  },
  {
    main: { name: pageTitles.placeEnquiry },
    sub: [
      {
        name: NavNames.placeEnquiry,
        path: paths.placeOrder,
        icon: HiOutlinePencil,
      },
    ],
  },
  {
    main: { name: pageTitles.r2dOrders },
    sub: [
      {
        name: NavNames.r2dOrders,
        path: paths.r2dOrders,
        icon: FaTruckLoading,
      },
    ],
  },
  {
    main: { name: pageTitles.shipmentsDashboard },
    sub: [
      {
        name: NavNames.shipmentsDashboard,
        path: paths.shipmentsDashboard,
        icon: FaTruck,
      },
    ],
  },
  {
    main: { name: pageTitles.unpaidOrders },
    sub: [
      {
        name: NavNames.unpaidOrders,
        path: paths.unpaidOrders,
        icon: FaMoneyBillWave,
      },
    ],
  },
  {
    main: { name: pageTitles.partMaster },
    sub: [
      {
        name: NavNames.partMaster,
        path: "#",
        icon: FaCogs,
      },
    ],
  },
  {
    main: { name: pageTitles.PaymentLinks },
    sub: [
      {
        name: NavNames.PaymentLinks,
        path: "#",
        icon: FaLink,
      },
    ],
  },
  {
    main: { name: pageTitles.CBOOrders },
    sub: [
      {
        name: NavNames.CBOOrders,
        path: paths.cboOrders,
        icon: FaRegCalendarAlt,
      },
    ],
  },
  {
    main: { name: pageTitles.MISSION_CONTROL },
    sub: [
      {
        name: NavNames.MISSION_CONTROL,
        path: paths.missionControl,
        icon: FaRocket,
      },
    ],
  },
  {
    main: { name: pageTitles.testOrder },
    sub: [
      {
        name: NavNames.testOrder,
        path: paths.testOrder,
        icon: HiOutlinePencil,
      },
    ],
  },
  {
    main: { name: pageTitles.cars },
    sub: [
      {
        name: NavNames.cars,
        path: paths.cars,
        icon: FaCarSide,
      },
    ],
  },
];

export default paths;
